export const appTheme = {
  token: {
    colorPrimary: "#0BAA6B",
    colorSuccess: "#000",
    fontFamily: "Gordita-Medium",
    borderRadius: 8,
  },
  components: {
    Menu: {
      activeBarBorderWidth: 0,
    },
    Input: {
      colorTextPlaceholder: "#4D4D4D", // hsv(0, 0, 30%)
    },
    Table: {
      headerBg: "#FFF",
      footerBg: "#FFF",
    },
    Tooltip: {
      controlHeight: "auto",
      colorBgSpotlight: "#44596C",
      fontSize: 12,
      paddingSM: 3,
      paddingXS: 8,
    },
    Tabs: {
      verticalItemMargin: "0px",
    },
    Button: {
      colorLinkHover: "#0baa6b",
    },
    Checkbox: {
      colorBorder: "#a9bccf",
      borderRadiusSM: 3,
      colorPrimaryHover: "#0baa6b",
    },
  },
};
